import initialState from './initialState';
import { FETCH_CUSTOMERS, RECEIVE_CUSTOMERS } from '../actions/actionTypes';

export default function customersReducer(state = initialState.customers, action) {
	let newState = {};
	switch (action.type) {
		case FETCH_CUSTOMERS:
			return { ...state, fetching: true };
		case RECEIVE_CUSTOMERS:
			newState.items = action.customers.items;
			newState.pagination = action.customers.pagination;
			newState.pagination.pageSizeOptions = state.pagination.pageSizeOptions;
			newState.search = action.customers.search;
			newState.fetching = false;
			return newState;
		default:
			return state;
	}
}